"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPromoImageSrc = void 0;
var getPromoImageSrc = function (slug, type) {
    if (type === void 0) { type = 'background'; }
    var imageType;
    switch (type) {
        case 'background':
            imageType = 'imageBackground';
            break;
        case 'banner':
            imageType = 'imageBanner';
            break;
    }
    return "/img/bonuses/".concat(slug, "/").concat(imageType, ".png");
};
exports.getPromoImageSrc = getPromoImageSrc;
